import React, { useEffect, useState } from 'react';
import { Modal, Typography, Button, Spin, Empty, Timeline } from 'antd';
import { logisticsApi } from '../../../../services/process/logistics';
import { LogisticsTrack } from '../../../../types/entity/logistics';
import * as _ from 'lodash'
const { Text } = Typography;

interface LogisticsTrackModalProps {
  visible: boolean;
  onClose: () => void;
  logisticsNo?: string;
}

export const LogisticsTrackModal: React.FC<LogisticsTrackModalProps> = ({ visible, onClose, logisticsNo }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<LogisticsTrack | null>(null);

  useEffect(() => {
    if (visible && logisticsNo) {
      setLoading(true);
      logisticsApi.getDetail(logisticsNo)
        .then(setData)
        .catch((e) => {
          console.error(e);
          setData(null);
        })
        .finally(() => setLoading(false));
    } else if (!visible) {
      setData(null);
    }
  }, [visible, logisticsNo]);

  return (
    <Modal
      title="物流轨迹"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          我知道了
        </Button>,
      ]}
      width={700}
    >
      <Spin spinning={loading}>
        {!data || !data.traces || data.traces.length === 0 ? (
          <Empty description="暂无物流信息" />
        ) : (
          <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '12px 24px' }}>
            <Timeline>
              {[...data.traces].reverse().map((trace, index) => (
                <Timeline.Item 
                  key={index} 
                  color={index === 0 ? 'green' : 'gray'}
                >
                  <p style={{ margin: 0, color: index === 0 ? '#333' : '#666', fontWeight: index === 0 ? 500 : 400 }}>
                    {trace.AcceptStation}
                  </p>
                  <p style={{ margin: '4px 0 0', color: '#999', fontSize: 12 }}>
                    {trace.AcceptTime}
                  </p>
                </Timeline.Item>
              ))}
            </Timeline>
          </div>
        )}
      </Spin>
    </Modal>
  );
};
